import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { IStateProvider } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.publicmap').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider): void {
  $stateProvider.state(STATE_MAPPINGS.publicMap, {
    url: '/map/{id}',
    params: {
      title: 'Map'
    },
    controller: 'runnerPublicMapController',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.publicmap/runner.publicmap.tmpl.html',
    resolve: {
      settingsLoaded: [
        '$q',
        'APP_CONFIG',
        'sessionService',
        'tokenService',
        function (
          $q: angular.IQService,
          APP_CONFIG: SharedAngular.APP_CONFIG,
          sessionService: SharedAngular.SessionService,
          tokenService: SharedAngular.TokenService
        ) {
          const isAuthenticated = sessionService.isAuthenticated();
          if (isAuthenticated && !tokenService.isTokenExpired()) {
            return APP_CONFIG.ready;
          }
          return $q.resolve();
        }
      ]
    }
  });
}
